import React, { useContext, useEffect, useState } from 'react'
import { useChartDataFeed } from '../../hooks/trade/chartDataFeed'
import { useTradePosition } from '../../hooks/trade/tradePosition'
import { ThemeContext } from '../../../theme/ThemeProvider'
import { SocketContext } from '../../../theme/SocketProvider'

const CRenderEmpty = ({ id, leaveid = 0 }: any) => {
	const [check, setCheck] = useState(false)

	const { socket } = useContext(SocketContext)

	const { mutate, joinGroup, leaveGroup } = socket

	const { data: updatechart } = useChartDataFeed()

	useEffect(() => {
		return () => {
			if (leaveid) {
				leaveGroup('user', leaveid)
			}
		}
	}, [leaveid])

	useEffect(() => {
		if (id) {
			mutate()
		}
	}, [id, updatechart])

	useEffect(() => {
		setCheck(!check)

		return () => {
			if (id) {
			} else {
				leaveGroup('all')
			}
		}
	}, [])

	useEffect(() => {
		console.log('CRenderEmpty', id)
		if (id) {
			setTimeout(() => {
				joinGroup('user', id)
			}, 500)
			setTimeout(() => {
				joinGroup('user', id)
			}, 2000)
			setTimeout(() => {
				joinGroup('user', id)
			}, 5000)
		} else {
			joinGroup('all')
		}

		return () => {
			if (id) {
			} else {
				leaveGroup('all')
			}
		}
	}, [check])

	return null
}
export default CRenderEmpty
